import { IModuleTranslation } from '@larscom/ngx-translate-module-loader';

const baseTranslateUrl = './assets/i18n/tracker/type/skin-or-body-temperature';
const moduleName = 'tracker-type-skin-or-body-temperature';

export const trackerTypeSkinOrBodyTemperature: Array<IModuleTranslation> = [
  {
    baseTranslateUrl,
    moduleName,
    pathTemplate: '{baseTranslateUrl}/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-chart`,
    pathTemplate: '{baseTranslateUrl}/chart/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-filter`,
    pathTemplate: '{baseTranslateUrl}/filter/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-goal`,
    pathTemplate: '{baseTranslateUrl}/goal/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-latest`,
    pathTemplate: '{baseTranslateUrl}/latest/{language}'
  },
  {
    baseTranslateUrl,
    moduleName: `${moduleName}-overview`,
    pathTemplate: '{baseTranslateUrl}/overview/{language}'
  }
];
